import React from 'react'
import { Helmet } from "react-helmet";

export default function SEO({ title, description }) {
  return (
    <Helmet htmlAttributes={{ language: "en" }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  )
}
